var app_preloader = null;
(function ($) {

    app_preloader = function (_app) {

        var self = this;
        self.app = _app;


        self.show = function () {
            
            if (self.app.find('#b-loading').length === 0) { 
                if (
                  self.app.settings.theme === "lunden" ||
                  self.app.settings.theme === "viste" ||
                  self.app.settings.theme === "veidekke" ||
                  self.app.settings.theme === "skogslyckan"
                ) {
                  self.app
                    .find("#b-innercontainer")
                    .append('<div id="b-loading"></div>');
                } else {
                  self.app
                    .find("#b-innercontainer")
                    .append('<div id="b-loading">Laddar bostadsväljaren</div>');
                }
            } else {
                self.app.find("#b-loading").show();
            } 
            var t = ((self.app.outerHeight() / 2) - (self.app.find('#b-loading').outerHeight() / 2)); 
            self.app.find("#b-loading").css({"top": t});
            self.app.trace("Showing loadingView");

        };

        self.hide = function () { 
            self.app.find("#b-loading").fadeOut(function () {
                self.app.find("#b-toptext").fadeIn("slow");
                $("body").find(".apartment_list").fadeIn("slow"); 
                self.app.find("#b-appcontent").fadeIn("slow", function () {
                    self.app.trace("Hideing loadingView"); 
                    $(window).trigger("resize");
                }); 
            });
        };

        return self;
    };

})(jQuery);